import { BodySmall } from '#/components/Text/BodySmall';
import { H4 } from '#/components/Text/H4';
import { RichText } from '#/components/Text/RichText';
import type { CmsApiSearchLandingPage } from '#/modules/cms/api/types/CmsApiSearchLandingPage';

type Props = {
  content: CmsApiSearchLandingPage;
};

export function SearchDescriptionBody({ content }: Props) {
  const name = content.location?.name
    ? `${content.name}, ${content.location.name}`
    : content.name;

  return (
    <BodySmall ml={[20, 20, 20, 0]} mr={[20, 20, 20, 0]} mb={10}>
      <H4 tag="h1" mb={10}>
        {name}
      </H4>

      {content.description && <RichText html={content.description} $small />}
    </BodySmall>
  );
}
